module.exports = __webpack_public_path__ + "static/media/Location.9a44b791.svg";